export const KelaRegions = [
    {
        "text": "Kainuu",
        "value": "KAB"
    },
    {
        "text": "Kanta-Häme",
        "value": "KHC"
    },
    {
        "text": "Keski- ja Pohjois-Pohjanmaa",
        "value": "KPB"
    },
    {
        "text": "Kymenlaakso",
        "value": "KLC"
    },
    {
        "text": "Lappi",
        "value": "LAC"
    },
    {
        "text": "Päijät-Häme",
        "value": "PHB"
    },
    {
        "text": "Uusimaa",
        "value": "UMB"
    }
];
